import { ReactNode } from "react"

type ConditionalWrapperProps = {
    condition?: boolean
    wrapper:
        | ((children: ReactNode) => ReactNode)
        | [(children: ReactNode) => ReactNode, (children: ReactNode) => ReactNode]
    children?: ReactNode
}

const ConditionalWrapper = ({ children, wrapper, condition }: ConditionalWrapperProps) => {
    if (!children) return null
    if (Array.isArray(wrapper)) return condition ? wrapper[0](children) : wrapper[1](children)
    return condition ? wrapper(children) : children
}

export default ConditionalWrapper
